import { render, staticRenderFns } from "./CommunityDocuments.vue?vue&type=template&id=a0301120&scoped=true"
import script from "./CommunityDocuments.vue?vue&type=script&lang=js"
export * from "./CommunityDocuments.vue?vue&type=script&lang=js"
import style0 from "./CommunityDocuments.vue?vue&type=style&index=0&id=a0301120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0301120",
  null
  
)

export default component.exports